import React from 'react';
import styles from '@/styles/components/models-gallery/PageHeaderSkeleton.module.css';

interface PageHeaderSkeletonProps {
  className?: string;
}

const PageHeaderSkeleton: React.FC<PageHeaderSkeletonProps> = ({ className }) => {
  return (
    <div 
      className={`${styles.headerSkeleton} ${className || ''}`}
      role="status"
      aria-label="Loading page header"
    >
      <div className={`${styles.skeleton} ${styles.title}`} />
      <div className={`${styles.skeleton} ${styles.modelCount}`} />
    </div>
  );
};

export default PageHeaderSkeleton;